import {
    IntentToggleExperiment,
    IntentToggleExperimentValues,
} from '@eventbrite/discover-utils';
import { IntentToggleOptions } from '@eventbrite/global-nav';
import { useClientStatsigEnrollment } from '../../../context/experiments/hooks';

interface IntentToggleStateProps {
    show: boolean;
    activeOption: IntentToggleOptions;
}

export const useIntentToggle = (
    isHomePage: boolean,
): IntentToggleStateProps => {
    const { variant: showToggle } = useClientStatsigEnrollment({
        name: IntentToggleExperiment.name,
        paramName: IntentToggleExperiment.paramName,
        defaultValue: IntentToggleExperiment.values.control,
        enabled: isHomePage,
    });
    const intentToggle = {
        show: showToggle === IntentToggleExperimentValues.test,
        activeOption: IntentToggleOptions.FIND_EVENTS,
    };

    return intentToggle;
};
